import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

// @ts-ignore
export const selector = (state: RootState) => state.courseType
export const selectCourseType = createSelector(selector, state => state.courseType)
